/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Active_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Active Event Group" |
*
* @param {Live_Caption_Active_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_active_event_group = /** @type {((inputs?: Live_Caption_Active_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Active_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'événements actifs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktive Ereignisgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo eventi attivi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Активная группа мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos activos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("活跃事件组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティブイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सक्रिय इवेंट समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos Ativos")
	return /** @type {LocalizedString} */ ("Active Event Group")
});